import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=3afd838c&scoped=true&"
import script from "./tree.vue?vue&type=script&lang=js&"
export * from "./tree.vue?vue&type=script&lang=js&"
import style0 from "./tree.vue?vue&type=style&index=0&id=3afd838c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd838c",
  null
  
)

export default component.exports